import { useState, useEffect } from 'react';
import axios from 'axios';
import Main from '../../../component/Main.jsx';
import ShowDetailDataGrid from "../../../component/common/dataGrid/ShowDetailDataGrid.jsx"
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';

import { Search16w, AddCircle16w } from '../../../images/icons/icons_component.js';

const ManageCmit = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
    const currentDay = String(today.getDate()).padStart(2, '0');

    const [emogList, setEmogList] = useState([]);

    const [searchParams, setSearchParams] = useState({
        searchCheck1: currentYear,
        searchGubun: '',
        searchCheck2: currentMonth,
        searchEmog: 'A2100040',
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['상세보기', '구분', '위원회(활동)명', '개최일자', '실시회차', '참여율', '등록일자', '첨부']; //component화 
    const dataColumn = ['DETAIL_SN', 'OPER_KND_NM', 'CD_NM', 'TR_OPMT_DT', 'OPRTN_CO', 'ATNDNC_RT', 'TR_CREAT_DT', 'ATCH_DTA'];
    const apiCall = '/trmsapi/operrslt/trumaManageCmitOperrsListSearch.do';
    const apiCntCall = '';
    const excelFileName = '외상 질 관리위원회 운영실적';
    const excelHead = ['순번', '구분', '위원회(활동)명', '개최일자', '실시회차', '참여율', '등록일자', '파일이름'];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const popupPropsInfo = {
        checked: ["DETAIL", "ATCH"],
        localStorageName: "ManageCmitData",
        popupAddress: "/nedis/trmsInfo/trms_ManageCmit_popup.do",
        downloadURI: "/trmsapi/operrslt/trumaManageCmitOperrsDownload.do",
        searchDir: "trumaManageCmitOperrs",
        height: '800'
    }

    if (searchParamsAdditional != null) {
        searchParamsAdditional.pageNum = parseInt(pageInfo.currentPage);
        searchParamsAdditional.displayRowsize = parseInt(pageInfo.itemsPerPage);
    }

    const totalObj = Object.assign({}, searchParams, searchParamsAdditional);

    const fetchData = async () => {
        try {
            delete totalObj.validationCheckList;
            const response = await axios.get(apiCall,
                { params: totalObj }
            );
            setState(prev => ({
                ...prev,
                dataList: response.data,
                isSearched: true
            }));
            if (apiCntCall === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: response.data.length
                }));
            } else {
                fetchDataCnt();
            }
            setState(prev => ({
                ...prev,
                isLoading: false
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(apiCntCall,
                { params: totalObj }
            );
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    // 페이지가 변경될 때마다 데이터를 새로 불러옴 (검색 후에만)
    useEffect(() => {
        if (state.isSearched) {
            setState(prev => ({
                ...prev,
                isLoading: true
            }));
            fetchData();
        }
    }, [pageInfo.currentPage]);

    const search = () => {
        setState(prev => ({
            ...prev,
            isSearched: false,
            isLoading: true
        }));
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
    };

    const add = () => {
        const senData = {
            flag: "add",
            IEM_ID: currentYear + currentMonth,
            TR_OPMT_DT: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
            emogcode: searchParams.searchEmog,
        }

        let popup = null;

        if (state.isSearched) {
            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(senData));
            popup = window.open(popupPropsInfo.popupAddress, "팝업", "scrollbars=1, resizable=0, width=1010, height=750, top=30, left=30");
        }
    };

    useEffect(() => {
        const fetchHospList = async () => {
            try {
                const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                    params: {
                        grdc: 'Y',
                        loca: '',
                    }
                });
                setEmogList(response.data.emogList || []);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchHospList();
        search();
    }, []);

    useEffect(() => {
        search();
    }, [searchParams.searchEmog, searchParams.searchCheck1, searchParams.searchCheck2])

    const getNextMonthStr = (monthStr) => {
        let nextMonth = parseInt(monthStr, 10) + 1;
        if (nextMonth > 12) nextMonth = 1;
        return nextMonth < 10 ? "0" + nextMonth : "" + nextMonth;
    };

    const getNextYear = (yearStr) => {
        let nextYear = parseInt(yearStr);
        if (searchParams.searchCheck2 === '12') { nextYear += 1; }
        return nextYear;
    }

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="13%" />
                        <col width="20%" />
                        <col width="13%" />
                        <col width="20%" />
                        <col width="13%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>조회기간</th>
                            <td>
                                <div className='flex gap-1'>
                                    <select id="searchCheck1"
                                        name="searchCheck1"
                                        value={searchParams.searchCheck1}
                                        onChange={handleInputChange}
                                    >
                                        {Array.from({ length: 10 }, (_, i) => {
                                            const year = (currentYear - i).toString()
                                            return (
                                                <option key={year} value={year}>
                                                    {year}년
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <select id="searchCheck2"
                                        name="searchCheck2"
                                        value={searchParams.searchCheck2}
                                        onChange={handleInputChange}
                                    >
                                        {Array.from({ length: 12 }, (_, i) => {
                                            const month = (i + 1).toString().padStart(2, '0');
                                            return (
                                                <option key={month} value={month}>
                                                    {month}월
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </td>
                            <th>기관명</th>
                            <td>
                                <select
                                    name='searchEmog'
                                    className='w-full'
                                    value={searchParams.searchEmog}
                                    onChange={handleInputChange}
                                >
                                    {emogList.map(hosp => (
                                        <option key={hosp.emogcode} value={hosp.emogcode}>
                                            {hosp.emogdesc}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <th>구분</th>
                            <td>
                                <select
                                    id="searchGubun"
                                    name="searchGubun"
                                    className='w-full'
                                    value={searchParams.searchGubun}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="SD01">외상질관리위원회</option>
                                    <option value="SD02">기타 질관리 활동</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={6}>
                                <h5 className='bg-yellow co_dark w-fit px-2'>** {searchParams.searchCheck1}년 {searchParams.searchCheck2}월 실적 등록 가능 기간 : {searchParams.searchCheck1}-{searchParams.searchCheck2}-01 ~ {getNextYear(searchParams.searchCheck1)}-{getNextMonthStr(searchParams.searchCheck2)}-10 까지</h5>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className='tr_primary'>{pageInfo.totalItems}</strong>건</span>
                <div className='btn_container'>
                    {(currentYear.toString() + currentMonth.toString() + currentDay.toString()) >= (searchParams.searchCheck1.toString() + searchParams.searchCheck2.toString() + '01') && (currentYear.toString() + currentMonth.toString() + currentDay.toString()) <= (getNextYear(searchParams.searchCheck1) + getNextMonthStr(searchParams.searchCheck2) + '10') ?
                        <button onClick={add} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_co_black'><AddCircle16w />추가</button> : ''}
                    <button onClick={search} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_tr_primary'><Search16w />조회</button>
                    <ExcelDownload
                        excelHead={excelHead}
                        excelData={state.dataList}
                        searched={state.isSearched}
                        dataCode={dataColumn}
                        excelFileName={excelFileName}
                    />
                </div>
            </div>
            <ShowDetailDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                searchParams={searchParams}
                popupPropsInfo={popupPropsInfo}
            />
        </Main>
    )
}
export default ManageCmit;